<h6>Mark As: </h6>
<div class="row-wrap" [style.gap.px]="5" [style.margin-bottom.px]="5">
    <button kendoButton themeColor="error" (click)="markAsInvalid('upload-error')">Upload Error</button>
    <button kendoButton themeColor="warning" (click)="markAsInvalid('repeat-upload')">Repeat Upload</button>
</div>
